/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateAsanaVerificationKeyInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createAsanaVerificationKeyMutationVariables = {|
  input: CreateAsanaVerificationKeyInput
|};
export type createAsanaVerificationKeyMutationResponse = {|
  +createAsanaVerificationKey: ?{|
    +key: ?string
  |}
|};
export type createAsanaVerificationKeyMutation = {|
  variables: createAsanaVerificationKeyMutationVariables,
  response: createAsanaVerificationKeyMutationResponse,
|};
*/


/*
mutation createAsanaVerificationKeyMutation(
  $input: CreateAsanaVerificationKeyInput!
) {
  createAsanaVerificationKey(input: $input) {
    key
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateAsanaVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAsanaVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createAsanaVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createAsanaVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createAsanaVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createAsanaVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createAsanaVerificationKeyMutation(\n  $input: CreateAsanaVerificationKeyInput!\n) {\n  createAsanaVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3ef17cda5c78ced2cf9d78f8d1b84fe7';

module.exports = node;
